<script setup lang="ts">
import { ref, type Ref } from 'vue'
import OGHeader from '@/components/OGHeader.vue'
import { useAppStore, type Meeting } from '@/stores/appStore'
import MeetingsList from '@/components/MeetingsList.vue'

const showPast = ref(false)
const showRemoved = ref(false)
const appstore = useAppStore()
const meetings: Ref<Meeting[]> = ref([])

meetings.value = appstore.meetings
</script>

<template>
  <OGHeader title="Your Meetings" subtitle="See all your meetings" />
  <q-toggle v-model="showPast" label="Show Past" color="accent" />
  <q-toggle v-model="showRemoved" label="Show Removed" color="secondary" />
  <q-separator dark class="q-mb-md" />

  <MeetingsList :meetings="meetings" :max-view="null" :show-past="showPast" :show-removed="showRemoved" />
</template>
